module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "product_page"
  }, [_c('div', {
    staticClass: "product_view"
  }, [_c('input', {
    staticClass: "product_view_id",
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.product_id
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "sku",
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.product.sku
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "product_csrf",
    attrs: {
      "type": "hidden",
      "name": "",
      "value": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "media_img"
  }, [_c('div', {
    staticClass: "media_img_content"
  }, [_c('div', {
    staticClass: "swiper-container",
    attrs: {
      "data-space-between": "10"
    }
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.thumbnail_img), function(item, index) {
    return _c('div', {
      staticClass: "swiper-slide"
    }, [_c('img', {
      staticClass: "lazy",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": item,
        "alt": ""
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "product_info"
  }, [_c('h1', [_vm._v(_vm._s(_vm.product.name))]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "rbc_cold"
  }, [_c('span', [_c('span', {
    staticClass: "average_rating"
  }, [_vm._v(_vm._s(_vm.$t("message.average_rating")) + ":")]), _vm._v(" "), _c('span', {
    class: 'review_star review_star_' + Math.round(_vm.product.reviw_rate_star_average),
    staticStyle: {
      "font-weight": "bold"
    },
    attrs: {
      "itemprop": "average"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/product/review/lists/' + _vm.product_id
    }
  }, [_vm._v("\n                                ("), _c('span', {
    attrs: {
      "itemprop": "count"
    }
  }, [_vm._v(_vm._s(_vm.product.review_count) + " " + _vm._s(_vm.$t("message.reviews")))]), _vm._v(")\n                            ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "item_code"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("message.item_code")) + ":\n                        "), _c('span', {
    staticClass: "item_sku"
  }, [_vm._v(_vm._s(_vm.product.sku))])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), (_vm.product.price_info && _vm.product.price_info.special_price) ? _c('div', {
    staticClass: "price_info"
  }, [_c('div', {
    staticClass: "special_price special_active"
  }, [_vm._v("\n                        " + _vm._s(_vm.product.price_info.special_price.symbol) + "\n                        " + _vm._s(_vm.productSpecialPrice) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "price special_active"
  }, [_vm._v("\n                        " + _vm._s(_vm.product.price_info.price.symbol) + "\n                        " + _vm._s(_vm.productPrice) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]) : (_vm.product.price_info && _vm.product.price_info.price) ? _c('div', {
    staticClass: "price_info"
  }, [_c('div', {
    staticClass: "price no-special"
  }, [_vm._v("\n                        " + _vm._s(_vm.product.price_info.price.symbol) + "\n                        " + _vm._s(_vm.product.price_info.price.value) + "\n                    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "product_info_section",
    attrs: {
      "id": "product_info_section"
    }
  }, [(_vm.product.options) ? _c('div', {
    staticClass: "product_options"
  }, _vm._l((_vm.product.options), function(item, index) {
    return _c('div', {
      staticClass: "pg"
    }, [_c('div', {
      staticClass: "label size-label"
    }, [_vm._v("\n                                " + _vm._s(item.label) + "\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "chose_size rg"
    }, [(item.value) ? _c('ul', [_vm._l((item.value), function(l_item, l_index) {
      return [(l_item.show_as_img) ? _c('li', {
        staticClass: "show_as_img",
        class: l_item.active
      }, [_c('a', {
        class: l_item.active,
        attrs: {
          "href": "javascript:void(0)",
          "rel": l_item.url
        },
        on: {
          "click": function($event) {
            return _vm.goToOtherProduct(l_item.url)
          }
        }
      }, [_c('span', [_c('img', {
        attrs: {
          "src": l_item.show_as_img
        }
      })])]), _vm._v(" "), _c('b')]) : _c('li', {
        class: l_item.active
      }, [_c('a', {
        class: l_item.active,
        attrs: {
          "href": "javascript:void(0)",
          "rel": l_item.url
        },
        on: {
          "click": function($event) {
            return _vm.goToOtherProduct(l_item.url)
          }
        }
      }, [_c('span', [_vm._v(_vm._s(l_item.attr_val))])]), _vm._v(" "), _c('b')])]
    })], 2) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clear"
    })]), _vm._v(" "), _c('div', {
      staticClass: "clear"
    })])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "product_custom_options"
  }, [_c('div', {
    staticClass: "product_options"
  }, [_c('input', {
    staticClass: "product_custom_options",
    attrs: {
      "type": "hidden",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.custom_option_attr), function(c_item, attr) {
    return [_c('div', {
      staticClass: "pg"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v("\n                                        " + _vm._s(attr) + "\n                                    ")]), _vm._v(" "), _c('div', {
      class: 'chose_' + attr + ' rg ' + attr
    }, [_c('ul', {
      staticClass: "no_chosen_ul ",
      attrs: {
        "attr": attr
      }
    }, [_vm._l((c_item), function(o_item, o_index) {
      return [(o_item.image) ? _c('li', {
        class: o_item.status,
        attrs: {
          "id": "gal1"
        }
      }, [_c('a', {
        class: o_item.class + ' imgshow ',
        attrs: {
          "attr": attr,
          "value": o_item.key
        },
        on: {
          "click": function($event) {
            return _vm.selectCustomOption(attr, o_item.key)
          }
        }
      }, [_c('img', {
        staticClass: "lazy",
        attrs: {
          "src": o_item.image
        }
      })]), _vm._v(" "), _c('b')]) : _c('li', {
        class: o_item.status
      }, [_c('a', {
        class: o_item.class + ' noimgshow ',
        attrs: {
          "attr": attr,
          "value": o_item.key
        },
        on: {
          "click": function($event) {
            return _vm.selectCustomOption(attr, o_item.key)
          }
        }
      }, [_vm._v("\n                                                        " + _vm._s(o_item.label) + "\n                                                    ")]), _vm._v(" "), _c('b')])]
    })], 2)]), _vm._v(" "), _c('div', {
      staticClass: "clear"
    })])]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "product_qty pg"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t("message.qty")) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "rg"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_select_qty),
      expression: "product_select_qty"
    }],
    staticClass: "qty",
    attrs: {
      "name": "qty"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product_select_qty = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("6")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("9")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("11")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("12")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "13"
    }
  }, [_vm._v("13")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14"
    }
  }, [_vm._v("14")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15"
    }
  }, [_vm._v("15")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "16"
    }
  }, [_vm._v("16")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "17"
    }
  }, [_vm._v("17")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18"
    }
  }, [_vm._v("18")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "19"
    }
  }, [_vm._v("19")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("20")])]), _vm._v(" "), (_vm.product.package_number) ? _c('span', [_vm._v("\n                                X " + _vm._s(_vm.product.package_number) + " items\n                            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), (_vm.errormsg) ? _c('div', {
    staticClass: "fecshop_message"
  }, [_c('div', {
    staticClass: "error-msg"
  }, [_c('div', [_vm._v("\n                                " + _vm._s(_vm.errormsg) + "\n                            ")])])]) : _vm._e(), _vm._v(" "), (_vm.tier_price.length) ? _c('div', {
    staticClass: "tier_price_info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t("message.wholesale_prices")))]), _vm._v(" "), _c('table', [_vm._l((_vm.tier_price), function(t_item, t_index) {
    return [_c('tr', _vm._l((t_item), function(t_item_one, t_index_one) {
      return _c('td', [_vm._v("\n                                        " + _vm._s(t_item_one) + "\n                                    ")])
    }), 0)]
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "addtocart"
  }, [_c('a', {
    staticClass: "button button-fill button-success redBtn addProductToCart",
    attrs: {
      "external": "",
      "href": "javascript:void(0)",
      "id": "js_registBtn"
    },
    on: {
      "click": function($event) {
        return _vm.addProductToCart()
      }
    }
  }, [_c('em', [_c('span', [_c('i'), _vm._v("\n                                    " + _vm._s(_vm.$t("message.add_to_cart")) + "\n                                ")])])]), _vm._v(" "), _c('a', {
    staticClass: "button button-fill button-success redBtn addProductToFavo",
    attrs: {
      "external": "",
      "href": "javascript:void(0)",
      "id": "js_registBtn"
    },
    on: {
      "click": function($event) {
        return _vm.addProductFavorite()
      }
    }
  }, [_c('em', [_c('span', [_c('i'), _vm._v("\n                                    " + _vm._s(_vm.$t("message.add_to_favorites")) + "\n                                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "product_description_info"
  }, [_c('div', {
    staticClass: "buttons-tab"
  }, [_c('a', {
    staticClass: "tab-link active button",
    attrs: {
      "href": "#tab1"
    }
  }, [_vm._v(_vm._s(_vm.$t("message.description")))]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    attrs: {
      "href": "#tab2"
    }
  }, [_vm._v(_vm._s(_vm.$t("message.reviews")))]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    attrs: {
      "href": "#tab3"
    }
  }, [_vm._v(_vm._s(_vm.$t("message.shipping_payment")))])]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab active",
    attrs: {
      "id": "tab1"
    }
  }, [_c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "text-description"
  }, [_c('table', _vm._l((_vm.product.groupAttrArr), function(t_item, t_index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(t_index))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(t_item))])])
  }), 0), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.product.description)
    }
  }), _vm._v(" "), (_vm.image_detail.length) ? _c('div', {
    staticClass: "img-section"
  }, [_vm._l((_vm.image_detail), function(t_item, t_index) {
    return [_c('br'), _vm._v(" "), _c('img', {
      staticClass: "lazy",
      attrs: {
        "src": t_item
      }
    })]
  })], 2) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab2"
    }
  }, [_c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "text-reviews",
    attrs: {
      "id": "text-reviews"
    }
  }, [_c('div', {
    staticClass: "product-Reviews"
  }, [_c('div', {
    staticClass: "scroll_horizontal",
    attrs: {
      "id": "pic_list_2"
    }
  }, [_c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "box pro_commit"
  }, [_c('div', {
    staticClass: "averageWarp"
  }, [_c('span', {
    staticClass: "lineBlock fon14"
  }, [_vm._v(_vm._s(_vm.$t("message.average_rating")) + ": ")]), _vm._v(" "), _c('a', {
    class: 'review_star review_star_' + Math.round(_vm.product.reviw_rate_star_average),
    attrs: {
      "lehref": "#",
      "onclick": "javascript:return false;"
    }
  }), _vm._v(" "), _c('b', {
    staticClass: "lineBlock fon18"
  }, [_vm._v(_vm._s(_vm.product.reviw_rate_star_average))])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "lbBox writeRiviewTitle"
  }, [_c('ul', {
    staticClass: "lineBlock proportionStars"
  }, [_c('li', {
    staticClass: "lbBox"
  }, [_c('span', {
    staticClass: "lineBlock fz_blue"
  }, [_vm._v(_vm._s(_vm.$t("message.stars_5")))]), _vm._v(" "), _c('div', {
    staticClass: "lineBlock proportionBox"
  }, [_c('div', {
    style: ('width: ' + _vm.reviw_rate_star_info.star_5 + '%')
  })]), _vm._v(" "), _c('span', {
    staticClass: "lineBlock"
  }, [_vm._v(_vm._s(_vm.reviw_rate_star_info.star_5) + "%")])]), _vm._v(" "), _c('li', {
    staticClass: "lbBox"
  }, [_c('span', {
    staticClass: "lineBlock fz_blue"
  }, [_vm._v(_vm._s(_vm.$t("message.stars_4")))]), _vm._v(" "), _c('div', {
    staticClass: "lineBlock proportionBox"
  }, [_c('div', {
    style: ('width: ' + _vm.reviw_rate_star_info.star_4 + '%')
  })]), _vm._v(" "), _c('span', {
    staticClass: "lineBlock"
  }, [_vm._v(_vm._s(_vm.reviw_rate_star_info.star_4) + "%")])]), _vm._v(" "), _c('li', {
    staticClass: "lbBox"
  }, [_c('span', {
    staticClass: "lineBlock fz_blue"
  }, [_vm._v(_vm._s(_vm.$t("message.stars_3")))]), _vm._v(" "), _c('div', {
    staticClass: "lineBlock proportionBox"
  }, [_c('div', {
    style: ('width: ' + _vm.reviw_rate_star_info.star_3 + '%')
  })]), _vm._v(" "), _c('span', {
    staticClass: "lineBlock"
  }, [_vm._v(_vm._s(_vm.reviw_rate_star_info.star_3) + "%")])]), _vm._v(" "), _c('li', {
    staticClass: "lbBox"
  }, [_c('span', {
    staticClass: "lineBlock fz_blue"
  }, [_vm._v(_vm._s(_vm.$t("message.stars_2")))]), _vm._v(" "), _c('div', {
    staticClass: "lineBlock proportionBox"
  }, [_c('div', {
    style: ('width: ' + _vm.reviw_rate_star_info.star_2 + '%')
  })]), _vm._v(" "), _c('span', {
    staticClass: "lineBlock"
  }, [_vm._v(_vm._s(_vm.reviw_rate_star_info.star_2) + "%")])]), _vm._v(" "), _c('li', {
    staticClass: "lbBox"
  }, [_c('span', {
    staticClass: "lineBlock fz_blue"
  }, [_vm._v(_vm._s(_vm.$t("message.stars_1")))]), _vm._v(" "), _c('div', {
    staticClass: "lineBlock proportionBox"
  }, [_c('div', {
    style: ('width: ' + _vm.reviw_rate_star_info.star_1 + '%')
  })]), _vm._v(" "), _c('span', {
    staticClass: "lineBlock"
  }, [_vm._v(_vm._s(_vm.reviw_rate_star_info.star_1) + "%")])])]), _vm._v(" "), _c('p', {
    staticClass: "buttons-row"
  }, [_c('router-link', {
    staticClass: "button button-round",
    attrs: {
      "to": '/product/review/add/' + _vm.product_id
    }
  }, [_vm._v("\n                                                    " + _vm._s(_vm.$t("message.add_review")) + "\n                                                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "button button-round",
    attrs: {
      "to": '/product/review/lists/' + _vm.product_id
    }
  }, [_vm._v("\n                                                    " + _vm._s(_vm.$t("message.view_all_review")) + "(" + _vm._s(_vm.product.review_count) + ") \n                                                ")])], 1)]), _vm._v(" "), (_vm.productReview && _vm.productReview.coll) ? _c('div', {
    staticClass: "product-Reviews_top"
  }, [_vm._l((_vm.productReview.coll), function(item_one, t_index) {
    return [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "fec-card-header"
    }, [_vm._v("\n                                                        " + _vm._s(item_one.summary) + "\n                                                    ")]), _vm._v(" "), _c('div', {
      staticClass: "fec-card-content"
    }, [_c('div', {
      staticClass: "fec-card-content-inner"
    }, [_c('div', {
      staticClass: "review-content"
    }, [_vm._v("\n                                                                " + _vm._s(item_one.review_content) + "\n                                                            ")]), _vm._v(" "), _c('div', {
      staticClass: "moderation"
    }, [(item_one.status == 10) ? _c('div', [_vm._v("\n                                                                    Your Review is awaiting moderation...\n                                                                ")]) : _vm._e(), _vm._v(" "), (item_one.status == 2) ? _c('div', [_vm._v("\n                                                                    Your Review is refused...\n                                                                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "review_list_remark"
    }, [_c('p', [_vm._v("By" + _vm._s(item_one.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item_one.review_date))])])])]), _vm._v(" "), _c('div', {
      staticClass: "fec-card-footer"
    }, [_c('a', {
      class: 'review_star review_star_' + item_one.rate_star,
      attrs: {
        "href": "#",
        "onclick": "javascript:return false;"
      }
    })])])]
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])])])])]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('div', {
    staticClass: "buy_also_buy_cer"
  }, [(_vm.buy_also_buy) ? _c('div', {
    staticClass: "buy_also_buy"
  }, [_c('div', {
    staticClass: "scroll_left"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("message.customer_who_also_bought")))])]), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "viewport",
    staticStyle: {
      "overflow": "hidden",
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "owl-carousel",
    attrs: {
      "id": "owl-buy-also-buy"
    }
  }, [_c('v-product', {
    attrs: {
      "productList": _vm.buy_also_buy
    }
  })], 1)])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab3"
    }
  }, [_c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "text-questions"
  }, [_c('div', {
    staticClass: "scroll_left"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Payment Methods:")])]), _vm._v(" "), _c('p', [_vm._v("FECSHOP.com accepts PayPal, Credit Card, Western Union and Wire Transfer as secure payment methods:")]), _vm._v(" "), _c('p', [_vm._v("Global:")]), _vm._v(" "), _c('p', [_vm._v("1. PayPal")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "alt": "",
      "height": "96",
      "src": "//img.appfront.fancyecommerce.com/images/paypal48.jpg",
      "width": "300"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("1) Login To Your Account or use Credit Card Express.'); ?>"), _c('br'), _vm._v("\n                            2) Enter your Card Details, the order will be shipped to your PayPal address. And click \"Submit\".'); ?>"), _c('br'), _vm._v("\n                            3) Your Payment will be processed and a receipt will be sent to your email inbox.")]), _vm._v(" "), _c('p', [_vm._v("2. Credit Card")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "alt": "",
      "height": "40",
      "src": "//img.appfront.fancyecommerce.com/images/creditcard48.jpg",
      "width": "554"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("\t1) Choose your shipping address OR create a new one.'); ?>"), _c('br'), _vm._v("\n                                2) Enter your Card Details and click \"Submit\".'); ?>"), _c('br'), _vm._v("\n                                3) Your Payment will be processed and a receipt will be sent to your email inbox.\n                            ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-531e5d10!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/body/product/Index.vue
// module id = 250
// module chunks = 1